<template>
<div id="downLoad">
  <div class="contentHead">
    <div class="headName">
      上传下载中心
    </div>
  </div>
  <div class="downupCenter">
    <div class="contentLeft">
      <el-menu
          :default-active="currentPath"
          class="el-menu-vertical-demo"
          router
      >
        <el-menu-item index="/downLoad" :class="{activeClass:this.$route.path ==='/downLoad'}">
          <span slot="title">下载中心</span>
        </el-menu-item>
        <el-menu-item index="/upLoad" :class="{activeClass:this.$route.path ==='/upLoad'}">
          <span slot="title" >上传中心</span>
        </el-menu-item>
      </el-menu>

    </div>
    <div class="contentRight">
      <router-view/>
    </div>
  </div>
</div>
</template>

<script>
export default {
name: "downLoad",
  data(){
  return{
    currentPath:'/downLoad'
  }
  },
  components:{

  },
  watch:{
    "$route.path": function(to) {
      console.log(to)
    },
  },

  mounted() {
  this.currentPath=this.$route.path
    console.log(this.currentPath)
  },
  methods:{
  }

}
</script>

<style scoped lang="less">
@import "../../assets/less/download/downUpCenter";
.activeClass{
  border-right: 2px solid #409EFF;
}
#downLoad{
  height: calc(100vh - 20px);
}
</style>